import { classNames } from '@commenda/utils';

/* eslint-disable react/no-array-index-key */
const SummaryFieldKS = ({
  heading,
  value,
  hideBorder = false,
}: {
  heading: string;
  value: string | number | (string | number)[];
  hideBorder?: boolean;
}) => {
  return (
    <div
      className={classNames(
        'flex justify-between items-start py-1 gap-4',
        hideBorder ? '' : 'border-b border-neutral-6'
      )}
    >
      <span className="text-sm text-text-secondary flex-shrink-0 w-1/2">
        {heading}
      </span>
      <span className="text-sm font-medium text-neutral-1 text-left flex-grow w-2/3">
        {Array.isArray(value) ? (
          <div className="flex flex-col">
            {value.map((each, idx) => (
              <p key={idx} className="break-words">
                {each}
              </p>
            ))}
          </div>
        ) : (
          <p className="break-words">{value}</p>
        )}
      </span>
    </div>
  );
};

export { SummaryFieldKS };
